module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

_.each(legends,function(legend) { ;
__p += '\n	';
   if (legend.title) {;
__p += '\n	<span title="' +
((__t = (legend.title)) == null ? '' : __t) +
'" class="DescartesUITextGras">' +
((__t = (legend.title)) == null ? '' : __t) +
'</span>\n	';
 } ;
__p += '\n	';
_.each(legend.urls,function(url) { ;
__p += '\n<div>\n 	   		<img src="' +
((__t = (url)) == null ? '' : __t) +
'"></img>\n</div>\n	';
 });;
__p += '\n';
 if(separateur) {;
__p += '\n<hr/>\n';

 }
 });
;
__p += '\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Info/bootstrap4/templates/Legend.ejs
// module id = 212
// module chunks = 0